import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute/ProtectedRoute';
import { getPersona, type Persona, defaultHomePath } from '../../utils/persona';

interface PersonaRouteProps {
  children: ReactNode;
  /** Required persona to access this route */
  require: Persona;
}

/**
 * Requires auth, then ensures the stored persona matches the product surface.
 */
const PersonaRoute: React.FC<PersonaRouteProps> = ({ children, require }) => {
  return (
    <ProtectedRoute>
      <PersonaGate require={require}>{children}</PersonaGate>
    </ProtectedRoute>
  );
};

const PersonaGate: React.FC<PersonaRouteProps> = ({ children, require }) => {
  const persona = getPersona();
  if (persona !== require) {
    return <Navigate to={defaultHomePath(persona)} replace />;
  }
  return <>{children}</>;
};

export default PersonaRoute;
